export const filteringTrustValueInObject = (object: Record<string | number | symbol, unknown>): Record<string | number | symbol, unknown> => {
  return Object.keys(object)
    .reduce((acc, key) => {
      acc = object[key] ? { ...acc, [key]: object[key] } : { ...acc }
      return acc;
    }, {});
}
